"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgLocationIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 26 26', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M24.868 3.15a1.92 1.92 0 0 0-.421-2.086 1.92 1.92 0 0 0-2.085-.42L1.208 9.296a1.925 1.925 0 0 0-1.16 2.151 1.92 1.92 0 0 0 1.887 1.55h10.577v10.578c0 .92.65 1.706 1.55 1.887a1.92 1.92 0 0 0 2.152-1.16z' }) })));
});
exports.default = (0, react_1.memo)(SvgLocationIcon);
